import DateFilter from './DateFilter';
import IsActiveFilter from './IsActiveFilter';
import UserFilter from './UserFilter';

/**
 * Standard audit filter set for Tier-1 Configuration CRUD modules.
 */
export function buildAuditFilters() {
  return [
    IsActiveFilter,
    {
      ...UserFilter,
      name: 'userCreatorId',
      label: 'config.info.createdBy',
    },
    {
      ...UserFilter,
      name: 'userModifierId',
      label: 'config.info.updatedBy',
    },
    {
      ...DateFilter,
      name: 'created',
      label: 'global.created',
    },
    {
      ...DateFilter,
      name: 'updated',
      label: 'global.updated',
    },
  ];
}
